var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomDnbCritical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14a7 7 0 10-7-7 7 7 0 007 7zm3.35-3.65a.48.48 0 01-.7 0L7 7.71l-2.65 2.64a.49.49 0 01-.7-.7L6.29 7 3.65 4.35a.49.49 0 01.7-.7L7 6.29l2.65-2.64a.49.49 0 01.7.7L7.71 7l2.64 2.65a.48.48 0 010 .7z",
    fill: "#ff5400",
    fillRule: "evenodd",
    "data-name": "Layer 1"
  }))));
}

export default SvgCustomDnbCritical;